<template>
  <div>
    <div class="justify-content-end d-flex">
      <md-button @click="handlePatientSave" class="md-raised md-primary">
        Save
      </md-button>
    </div>
    <PatientHistory />
  </div>
</template>
<script>
import PatientHistory from "../patient/manage-patient/2_PatientHistory.vue";

export default {
  inject: ["handlePatientSave"],
  components: {
    PatientHistory,
  },
};
</script>

<style>
.md-raised {
  float: right;
  margin-top: 8px;
}
</style>
